import { useEffect, useState } from 'react';
import { Close } from '@carbon/icons-react';
import { Dialog, IconButton, makeStyles } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { useFormContext } from 'react-hook-form';

interface Props {
  onSubmit: (closeModal: () => void) => void;
  triggerButton: (onClick: () => void) => React.ReactNode;
}

const CreatePurchaseOrderSubmitModal = ({ onSubmit, triggerButton }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);
  const openToggler = () => setOpen((prev) => !prev);
  const { errors } = useFormContext();
  const bankError = errors?.bank;

  useEffect(() => {
    if (bankError) {
      setOpen(false);
    }
  }, [bankError]);

  return (
    <>
      {triggerButton(openToggler)}
      <Dialog
        fullWidth
        open={open}
        onClose={openToggler}
        classes={{ paper: classes.paper }}
      >
        <div className={classes.header}>
          <CustomizedTypography
            variant="h4"
            color="textPrimary"
            fontWeight="bold"
          >
            발주서 발행하기
          </CustomizedTypography>
          <IconButton className="close" onClick={openToggler}>
            <Close />
          </IconButton>
        </div>
        <div className={classes.content}>
          <CustomizedTypography
            variant="h4"
            color="textPrimary"
            gutterBottoms={4}
          >
            발주서 및 결제를 진행하시겠습니까?
          </CustomizedTypography>
          <CustomizedTypography variant="body2" color="error">
            주문 제작 특성 상, 결제 후 취소 및 환불은 파트너와 협의를 통해서만
            가능합니다.
          </CustomizedTypography>
        </div>
        <div className={classes.footer}>
          <CustomizedButton
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => onSubmit(openToggler)}
            size="large"
          >
            <i className="request-gtm-makeOrder-btn">발행하기</i>
          </CustomizedButton>
        </div>
      </Dialog>
    </>
  );
};

export default CreatePurchaseOrderSubmitModal;

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: 476,
    padding: 0,
    borderRadius: 16,
    '& h4': {
      wordBreak: 'break-all'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '28px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '28px 20px'
    },
    '& .close': {
      padding: 0,
      '& svg': {
        width: 24,
        height: 24
      }
    }
  },
  content: {
    padding: '0px 24px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '0px 16px 24px'
    }
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    [theme.breakpoints.down('md')]: {
      padding: '16px'
    }
  }
}));
